import { ListItem, ListItemAvatar, ListItemProps, ListItemText, Skeleton } from '@mui/material';

export function LoadingListItem(props: ListItemProps) {
  return (
    <ListItem {...props}>
      <ListItemAvatar>
        <Skeleton variant="circular" width={40} height={40} />
      </ListItemAvatar>
      <ListItemText primary={<Skeleton />} secondary={<Skeleton />} />
    </ListItem>
  );
}
